import { matchVersion } from '../../utils';
import __regexp from './__firefox-regexp';
import isAndroid from '../os/android';
/** Detect Mozilla Firefox Browser version */
export default function isFirefoxVersion(operator, version) {
	return function (ua) {
		return (
			!isAndroid(ua) &&
			matchVersion({
				ua: ua,
				version: version,
				operator: operator,
				regExp: __regexp,
				groupIndex: 1
			})
		);
	};
}
